import { MenuProps } from "antd";
import { 
    UserOutlined,
    UserSwitchOutlined,
    ApartmentOutlined,
    LogoutOutlined
} from "@ant-design/icons";

import { COLORS } from "../../../../../../config/themes/colors";


export const USER_MENU_ITEMS: MenuProps['items'] = [
    {
        label: 'Seleccione un intermediario',
        key: '1',
        icon: <UserOutlined style={{ color: COLORS.neutrals[70] }} />,
    },
    {
        type: 'divider'
    },
    {
        label: (
            <a href={`${process.env.PUBLIC_URL}/seleccionar-intermediario`} target="_self" rel="noopener noreferrer">
                Selección de intermediarios
            </a>
        ),
        key: '2',
        icon: <UserSwitchOutlined style={{ color: COLORS.neutrals[70] }} />,
    },
    {
        label: (
            <a href={`${process.env.PUBLIC_URL}/seleccionar-intermediario-dependiente`} target="_self" rel="noopener noreferrer">
                Intermediarios dependientes
            </a>
        ),
        key: '3',
        icon: <ApartmentOutlined style={{ color: COLORS.neutrals[70] }} />,

    },
    {
        type: 'divider',
    },
    {
        label: (
            <a href={`${process.env.PUBLIC_URL}/logout`} target="_self" rel="noopener noreferrer" style={ { color: COLORS.semantics.error[100] } }>
                Cerrar Sesión
            </a>
        ),
        key: '4',
        icon: <LogoutOutlined style={{ color: COLORS.neutrals[70] }} />,
    },
]